import { render, staticRenderFns } from "./Masterclass.vue?vue&type=template&id=854d0692&scoped=true"
import script from "./Masterclass.vue?vue&type=script&lang=js"
export * from "./Masterclass.vue?vue&type=script&lang=js"
import style0 from "./Masterclass.vue?vue&type=style&index=0&id=854d0692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854d0692",
  null
  
)

export default component.exports